// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

// SUGGESTION FOR FRONT END DOMAIN : bravixnode.com

export const environment = {
  production: false,
  USE_NIDA_REGISTRATION: true,
  staging: true,
  CLIENT_ID: '',
  CLIENT_SECRET: '',
  GEPG_SP_CODE_AQRB: '',
  INDEXED_DB_VERSION: 1,
  // SERVER_URL: 'http://localhost:8001',
  SERVER_URL: 'https://advancedstore.duckdns.org',



    // SERVER_URL: 'http://192.168.0.80:8483',
  // SERVER_URL: 'http://localhost:8483',
  ACTIVATE_API_INTEGRATION: false,
};

// this is auto-generated do not overwrite or edit
export const APP_VERSION = 'v1.0.0-local';

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone-related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error'; // Included with Angular CLI.
